import { render, staticRenderFns } from "./OrderInfoProduct.vue?vue&type=template&id=01f64bd4&scoped=true&"
import script from "./OrderInfoProduct.vue?vue&type=script&lang=js&"
export * from "./OrderInfoProduct.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoProduct.vue?vue&type=style&index=0&id=01f64bd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f64bd4",
  null
  
)

export default component.exports